import { render, staticRenderFns } from "./PaywallCard.vue?vue&type=template&id=5aed5534&scoped=true"
import script from "./PaywallCard.vue?vue&type=script&lang=js"
export * from "./PaywallCard.vue?vue&type=script&lang=js"
import style0 from "./PaywallCard.vue?vue&type=style&index=0&id=5aed5534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed5534",
  null
  
)

export default component.exports